import { render, staticRenderFns } from "./ChamadosAbertos.vue?vue&type=template&id=70fc68a2"
import script from "./ChamadosAbertos.vue?vue&type=script&lang=js"
export * from "./ChamadosAbertos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports